export default {
	type: 'object',
	properties: {
		emailAlerts: { type: 'string' },
	},
	additionalProperties: false,
}
